module.exports = __webpack_public_path__ + "media/country_flags/st-e83467a9.png";